import cx from 'clsx';
import React from 'react';

import loaderGif from '@assets/images/loader.gif';

import style from './style.module.scss';

const LoaderGif = ({ className = '' }) => {
  return (
    <span className={cx(style.loaderBlockGif, className)}>
      <img src={loaderGif} alt="waiting for data ..." />
    </span>
  );
};

export default LoaderGif;
